import CardMedia from "@mui/material/CardMedia";

interface GadgetIconProps {
    image: string;
    altText: string;
    styles: object;
    dataTestId: string;
}

export const GadgetIcon = ({ image, altText, styles, dataTestId }: GadgetIconProps) => {
    return (
      <CardMedia
        data-testid={dataTestId}
        component="img"
        sx={{...styles}}
        image={image}
        alt={altText}
      />
    );
};